'use strict';

const { h } = require('phy');

function getPremiumOfferImage(data) {
  return (
    data &&
    data.length &&
    data.find(
      ({ isMainImage, mediaType }) =>
        !isMainImage && mediaType === 'PremiumOfferImage'
    )
  );
}

function OfferUberImage({ className = '', alt, data, size, lazy = true }) {
  const media = getPremiumOfferImage(data);

  if (!media) {
    return null;
  }

  const imageSource = media.mediaUrl.replace('{{options}}', `${size[0]},`);
  const imageTags = lazy
    ? {
        src:
          'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        'data-src': imageSource,
        class: `lazy-load no-bg ${className}`,
      }
    : {
        src: imageSource,
        class: className,
      };

  return h('img', {
    ...imageTags,
    alt,
  });
}

module.exports = OfferUberImage;
module.exports.getPremiumOfferImage = getPremiumOfferImage;
